/**
 * Created by razial on 21.09.2026.
 */

Mission.TYPE_KRAKENFEAST = 26;

Mission.REGISTRATIONS.set(Mission.TYPE_KRAKENFEAST, () => ({
    ...BaseMissionData(),
    available: cleverapps.config.availables.KRAKENFEAST_MISSION,
    name: "KrakenFeast",
    duration: "3 day",
    semaphore: Mission.SEMAPHORE_PRIMARY,
    competition: {
        step: [5, 5, 5, 5, 5, 10, 10, 10, 10, 15, 15, 20, 20, 25, 30],
        forceCoef: 0.2,
        amount: [20, 30],
        noPlayerEpisodeCoef: true,
        botAheadPlayerCoef: 0.5,
        botAheadPlayerBigDifferenceCoef: 0.2,
        bigDistanceLength: 90
    },
    logic: KrakenFeast,
    prize: RewardsConfig.KrakenFeast.places,
    bundle: "lives_feast",
    collectIcon: bundles.reward_icons.frames.tentacle_png,
    sideBarJson: bundles.sidebar.jsons.kraken_feast_icon_json,
    view: KrakenFeastMissionWindow,
    startWindow: KrakenFeastMissionWindow,
    guideWindow: {
        name: "KrakenFeastGuideWindow",
        bundle: bundles.krakenfeastguidewindow,
        title: "KrakenFeastGuideWindow.title"
    },
    finishWindow: KrakenFeastMissionWindow
}));
